// test2106
(2106 && 0);
